import { useTheme } from 'foundations-theming/utils';
import HoverButton from './HoverButton';
import { jsx as _jsx } from "react/jsx-runtime";
const RectangularButton = props => {
  const theme = useTheme();
  return /*#__PURE__*/_jsx(HoverButton, Object.assign({}, props, {
    borderRadius: theme.borderRadius['100']
  }));
};
export default RectangularButton;